import { theme } from '../common/theme';

export const styles: Record<string, React.CSSProperties> = {
  toolbarWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 48,
    left: 30,
  },
  toolbar: {
    backgroundColor: '#fff',
    padding: 4,
    borderRadius: 4,
    gap: 4,
    display: 'flex',
    flexDirection: 'column',
  },
  menuRoot: {
    position: 'relative',
    width: '100%',
  },
  menuButtonSelected: {
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.primary.light,
  },
  shortcut: {
    fontSize: 12,
    opacity: 0.7,
    whiteSpace: 'nowrap',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    height: 40,
    justifyContent: 'space-between',
    flexGrow: 1,
    borderRadius: 8,
    padding: '0 8px',
  },
  rowInner: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    flexDirection: 'row',
    width: '100%',
  },
  // Adds a little "slack" space so you can move the mouse from the button into
  // the panel without the menu collapsing.
  menuFlyoutArea: {
    position: 'absolute',
    left: '100%',
    padding: 12,
    marginTop: -12,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  menuPanel: {
    position: 'relative',
    width: '100%',
    borderRadius: 8,
    padding: 4,
    minWidth: 240,
    zIndex: 20,
    background: '#ffffff',
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: 0,
    height: 40,
  },
  iconButton: {
    padding: 0,
    height: 40,
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  undoRedo: {
    marginTop: 12,
    backgroundColor: '#fff',
    padding: 4,
    borderRadius: 4,
    gap: 16,
  },
};
